import * as swcHelpers from '@swc/helpers';
import { isNil } from '@grandvisionhq/utils';

var getProductPrice = (serverVariant)=>{
    const { prices: serverPrices  } = serverVariant;
    if (!serverPrices || !serverPrices.originalPrice) {
        return undefined;
    }
    const { originalPrice: serverOriginalPrice  } = serverPrices;
    const originalPrice = swcHelpers.objectWithoutProperties(serverOriginalPrice, [
        "__typename"
    ]);
    var _discountedPrice;
    const { discountInformation: serverDiscountInfo , price: serverDiscountPrice  } = (_discountedPrice = serverPrices.discountedPrice) !== null && _discountedPrice !== void 0 ? _discountedPrice : {};
    let discountedPrice;
    // Check that the discount information is actually defined
    if (!isNil(serverDiscountInfo) && !isNil(serverDiscountPrice) && !!serverDiscountPrice.currencyCode) {
        // strip out the "__typename" fields that are returned from the BE
        const { __typename: _ , name , description  } = serverDiscountInfo, discountInformation = swcHelpers.objectWithoutProperties(serverDiscountInfo, [
            "__typename",
            "name",
            "description"
        ]);
        const nameInfo = name.map((n)=>{
            return {
                value: n === null || n === void 0 ? void 0 : n.value,
                locale: n === null || n === void 0 ? void 0 : n.locale
            };
        });
        const descriptionInfo = description.map((n)=>{
            return {
                value: n === null || n === void 0 ? void 0 : n.value,
                locale: n === null || n === void 0 ? void 0 : n.locale
            };
        });
        const price = swcHelpers.objectWithoutProperties(serverDiscountPrice, [
            "__typename"
        ]);
        discountedPrice = {
            discountInformation: swcHelpers.objectSpread({
                name: nameInfo,
                description: descriptionInfo
            }, discountInformation),
            price
        } // TODO: Remove this cast once the BE type is updated to make the child attributes mandatory
        ;
    }
    return {
        originalPrice,
        discountedPrice
    };
};

export { getProductPrice };
//# sourceMappingURL=get-product-price.js.map
